// themeConfig.js
// Theme configuration file for easy switching between different themes
// Simply change the CURRENT_THEME constant to switch themes

import defaultTheme from './defaultTheme';
import orangeTheme from './orangeTheme';
import tradeshowTheme from './tradeshowTheme';
import ticketCoverageTheme from './ticketCoverageTheme';

// Available themes
export const THEMES = {
  DEFAULT: 'default',
  ORANGE: 'orange',
  TRADESHOW: 'tradeshow',
  TICKETCOVERAGE: 'ticketcoverage',
};

// Change this constant to switch themes
export const CURRENT_THEME = THEMES.DEFAULT; // Switch to THEMES.DEFAULT to use the original theme

// Theme mapping
const themeMap = {
  [THEMES.DEFAULT]: defaultTheme,
  [THEMES.ORANGE]: orangeTheme,
  [THEMES.TRADESHOW]: tradeshowTheme,
  [THEMES.TICKETCOVERAGE]: ticketCoverageTheme,
};

// Export the current theme
export const currentTheme = themeMap[CURRENT_THEME];

export default currentTheme;
